import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpRequestService } from '../../shared/services/http-request.service';
import * as myGlobals from '../../shared/globalcontants'; // CONSTANT FILE ADD ANY CONSTANT VALUE
import { ObservableInput, } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class RevenueService implements OnInit {
  public RevenueResult: any;
  constructor( private http: HttpClient, private _hs: HttpRequestService) {
   }

   getRevenueRecord() {
    return this._hs.GetHttpRequest( myGlobals.LocalURL + myGlobals.GETREVENUE );
  }

  ngOnInit() {
    console.log(myGlobals.LocalURL);
  }

}
